import $ from 'jquery';
/* eslint-disable */
const queue = {}
const getScript = (source, callback, target) => {
  const ns = target.split('.')
  const instance = getInstance(ns)
  if (instance) {
    if (callback) callback(instance)
    return
  }

  if (!queue[source])queue[source] = []
  queue[source].push({ callback, target, ns })

  // is currently loading so prevent extra loads
  if (queue[source].length > 1) {
    return
  }
  let script = document.createElement('script')
  const prior = document.getElementsByTagName('script')[0]
  script.async = 1
  prior.parentNode.insertBefore(script, prior)

  script.onload = script.onreadystatechange = function (_, isAbort) {
    if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
      script.onload = script.onreadystatechange = null
      script = undefined
      if (isAbort || !callback) return

      const interval = setInterval(() => {
        for (let i = 0; i < queue[source].length; i++) {
          const current = queue[source][i]
          const player = getInstance(current.ns)
          if (!player) continue
          current.callback(player)
          queue[source].splice(i, 1)
          i = Math.max(i - 1, 0)
        }
        if (!queue[source].length) {
          delete queue[source]
          clearInterval(interval)
        }
      }, 10)
    }
  }
  script.src = source
}

import { TweenMax } from 'gsap'

const getInstance = (ns) => {
  let instance = window
  for (var i = 0; i < ns.length; i++) {
    if (!instance) return
    instance = instance[ns[i]]
  }
  return instance
}

export default {
  init () {
    $('[data-video-overlay]').on('click', function () {
      const videoId = $(this).attr('video-id')

      getScript('//www.youtube.com/iframe_api', (Player) => {
        // build view
        const container = document.createElement('div')
        container.classList.add('video-overlay-container');
        const wrapper = document.createElement('div')
        wrapper.classList.add('video-overlay-wrapper');
        const el = document.createElement('div')
        container.appendChild(wrapper)
        wrapper.appendChild(el)
        document.body.appendChild(container)
        const i = document.createElement('i')
        i.classList.add('video-overlay-container__close')
        i.style.display = 'none'
        container.appendChild(i)
        
        const button = document.createElement('div')
        button.classList.add('video-overlay-container__button')
        button.style.display = 'none';
        container.appendChild(button)

        // animate
        TweenMax.from(container, 0.4, { ease: Strong.easeOut, alpha: 0 })

        const resetButton = () => {
          TweenMax.set(button, { scale: 1 })
        }
        const hideButton  = () => {
          if (state === 2) return
          TweenMax.killTweensOf(button)
          TweenMax.to(button, 0.3, { ease: Strong.easeOut, scale: 1.2, delay: 0.6, alpha: 0, onComplete: resetButton })
        }

        const showButton = (hide) => {
          TweenMax.killTweensOf(button)
          TweenMax.from(button, 0.3, { ease: Strong.easeOut, scale: 0.8 })
          TweenMax.to(button, 0.3, { ease: Strong.easeOut, alpha: 1, onComplete: () => {
            resetButton ()
            if (hide) hideButton()
          }})
        }
        
        // yt state changes
        let state = -1
        const props = {
          videoId,
          playerVars: {
            hl: '',
            showinfo: 0,
            modestbranding: 1,
            rel: 0,
            autoplay: 1,
            color: '00adef',
            controls: 1,
            cc_load_policy: 0,
            disablekb: 0,
            fs: 1,
            iv_load_policy: 3,
            loop: 0,
            playsinline: 1,
            playlist: videoId
          },
          events: {
            onReady: () => {
              i.style.display = 'block'
              button.style.display = 'block';
              resetButton()
            },
            onStateChange: ({ data }) => {
              state = data
              switch (data) {
                case -3: // loading
                  break
                case -2: // loaded								
                  break
                case -1: // unstarted
                  break
                case 0: // ended
                  break
                case 1: // playing
                    button.classList.add('video-overlay-container__button-pause')
                    hideButton()
                  break
                case 2: // paused
                    button.classList.remove('video-overlay-container__button-pause')
                    showButton()
                  break
                case 3: // buffering
                  break
                case 5: // cued
                  break
              }
            }
          }
        }
        
        let player = new Player(el, props)

        button.addEventListener('click', () => {
          if (player) {
            if (state === 1) player.pauseVideo()
            else player.playVideo()
          }
        })

        wrapper.addEventListener('mouseenter', () => {
          showButton(true)
        })

        const destroy  = () => {
          const p = player
          i.style.display = 'none'
          player.pauseVideo()
          player.destroy()
          player = null

          TweenMax.to(container, 0.4, { ease: Strong.easeOut, alpha: 0, onComplete: () => {
            container.parentNode.removeChild(container);
          }})
        }
        document.body.addEventListener('keydown', ({which}) => {
          if (which !== 27) return
          destroy()
        })
        i.addEventListener('click', () => {
          if (!player) return
          destroy()
        })
      },
      'YT.Player')
    }
  )}
};